import React, { memo, useCallback, useEffect, useState } from 'react';
import CommentList from './components/CommentList';
import { useComment } from './components/CommentProvider';
import { Popover } from 'antd';

import './CommentCenter.scss';
import { addScrollRecordToProvider } from './directUser/utils';
import { CommentActionType, CommentScrollKey } from './directUser/index';
import { COMMENT_LIST_TYPE } from './utils';

const SectionComment = ({
  module,
  component = '',
  sendIdentifier,
  placement,
  onPopoverVisibleChange = () => {},
  getPopupContainer = () => null,
  className = '',
}) => {
  const { threadData = [], loading, commentScrollRecord } = useComment();
  const [visible, setVisible] = useState(false);
  const [targetChannelId, setTargetChannelId] = useState(null);

  const filter = (e) =>
    e.module === module &&
    (sendIdentifier
      ? e.identifier === sendIdentifier
      : e.component === component) &&
    e?.channelStatus === false;

  const totalCommentsInSection = threadData.filter(filter).length;

  const onVisibleChange = useCallback(
    (popoverVisible) => {
      onPopoverVisibleChange(popoverVisible);
      setVisible(popoverVisible);
    },
    [onPopoverVisibleChange, loading],
  );

  useEffect(() => {
    const anchorRecord = JSON.parse(
      sessionStorage.getItem(CommentScrollKey) || '{}',
    );
    if (
      !loading &&
      totalCommentsInSection &&
      visible &&
      anchorRecord.actionType === CommentActionType.CommentScrollIntoView
    ) {
      setTargetChannelId(Number(anchorRecord.channel));
      addScrollRecordToProvider(commentScrollRecord, COMMENT_LIST_TYPE.SECTION);
    } else if (!visible) {
      setTargetChannelId(null);
    }
  }, [visible, loading, totalCommentsInSection]);

  const content = (
    <div className="section-comment-console">
      <CommentList
        showPlaceHolderWhenNoData={false}
        filter={filter}
        showTag={false}
        module={module}
        component={component}
        sendIdentifier={sendIdentifier}
        getInnerTooltipPopupContainer={() =>
          getPopupContainer() || document.body
        }
        targetChannelId={targetChannelId}
        commentListType={COMMENT_LIST_TYPE.SECTION}
      />
    </div>
  );
  const iconClass =
    totalCommentsInSection > 0 ? 'icon-comment-fill' : 'icon-comment-outline';

  const componentId = `section-comment-${module}-${component}`;
  return (
    <Popover
      content={content}
      trigger="click"
      overlayClassName="comment-center-popover section-comment-popover"
      placement={placement}
      // getPopupContainer={() =>
      //   getPopupContainer() ||
      //   document.getElementById(componentId) ||
      //   document.getElementById('root') ||
      //   document.body
      // }
      onVisibleChange={onVisibleChange}
    >
      <div className={`section-comment-wrapper ${className}`}>
        <span
          className={`appkiticon ${iconClass} single-section`}
          id={componentId}
          data-comment-component-anchor={sendIdentifier || component || module}
        />
        {totalCommentsInSection > 0 && (
          <span className="comments-count">{totalCommentsInSection}</span>
        )}
      </div>
    </Popover>
  );
};

export default memo(SectionComment);
